<div [formGroup]="form">
    <mat-label class="font-style">
        <!-- Joint Thickness -->
        {{ 'ENGINEERED_JOINT_PAGE.LABELS.CALC_INPUT.JOINT_THICKNESS' | transloco }}
    </mat-label>

    <input
        matInput
        class="input-form-class"
        formControlName="jointThickness"
        name="jointThickness"
        [ngClass]="form.get('jointThickness').valid ? '' : 'highLight'"
    />
</div>
